export const SHOW_SCORE = false;

// When true, scrolling past the question card automatically skips the question.
export const SCROLL_TO_SKIP = false;
